import { FC, useState } from "react";
import { useTranslation } from "next-i18next";

import FacebookIcon from "@components/icons/facebook-icon";
import UrlIcon from "@components/icons/url-icon";

interface Props {
  url: string;
}

const ShareButtons: FC<Props> = ({ url }) => {
  const [copyTooltipVisible, setCopyTooltipVisible] = useState(false);
  const { t } = useTranslation("product", { keyPrefix: "share" });

  return (
    <div className="flex justify-between w-48 text-black">
      <div>{t("title")}:</div>
      <button
        className="relative focus:outline-none"
        onClick={async () => {
          await navigator.clipboard.writeText(url);
          setCopyTooltipVisible(true);
          setTimeout(() => setCopyTooltipVisible(false), 750);
        }}
        title={t("copy.title")}
      >
        <div
          className={`absolute -top-9 -left-2 ${
            copyTooltipVisible ? "" : "hidden"
          }`}
        >
          <div className="text-sm bg-black text-white whitespace-nowrap px-2 py-1 rounded">
            {t("copy.copied")}
          </div>
          <div className="h-0 w-0 ml-2 border-t-8 border-l-8 border-r-8 border-black border-l-transparent border-r-transparent" />
        </div>
        <UrlIcon className="w-6 h-6" />
      </button>
      <button
        className="focus:outline-none"
        onClick={() => {
          window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`);
        }}
        title={t("facebook")}
      >
        <FacebookIcon className="w-6 h-6" />
      </button>
    </div>
  );
};

export default ShareButtons;
